import { TypedObjectUtils } from "@gearbox-protocol/sdk/onchain";
import { useMemo } from "react";
import { useHydratedSDK } from "../../sdk";
/**
 * Returns value of sold tokens in underlying token
 * @param creditManager
 * @param balancesBefore
 * @param balancesAfter
 * @returns
 */
export default function useUnderlyingAccountValue(creditManager, 
/**
 * Token balances before liquidation
 */
balancesBefore, 
/**
 * Token after (partial) liquidation
 */
balancesAfter) {
    const sdk = useHydratedSDK();
    return useMemo(() => {
        const market = sdk.marketRegister.findByCreditManager(creditManager);
        let result = 0n;
        for (const [t, balance] of TypedObjectUtils.entries(balancesBefore)) {
            const sold = BigInt(balance) - BigInt(balancesAfter[t] ?? 0);
            result += market.priceOracle.convert(t, market.pool.underlying, sold);
        }
        return result;
    }, [balancesBefore, balancesAfter, sdk, creditManager]);
}
